import habitat from 'preact-habitat'

import App from './app'

let _habitat = habitat(App)

_habitat.render({
  selector: '#widget',
  clean: true,
})
